import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react';
import * as React from 'react';
import { hot } from 'react-hot-loader';
import { stylesheet } from "typestyle";
import CageBoxList from './CageBoxList';
import Reports from './Reports';
import OxygenLimits from './OxygenLimits';
import store from './Store';
import TimeSeriesChart from './TimeSeriesChart';
import TimeSeriesChartPH from './TimeSeriesChartPH';

const css = stylesheet({
  chartsRow: {
    display: 'inline-flex',
    flexDirection: 'row',
  },
  cageBoxRow: {
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  content: {
    display: 'flex',
    flex: 'auto',
    flexDirection: 'row',
  },
  flex: {
    flex: 1,
  },
  grow: {
    flexGrow: 1,
  },
  header: {
    flex: '0 0 64px',
    height: '50px',
  },
  loggers: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  map: {
    flex: 2,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
})

@observer
class App extends React.Component {


  public componentDidMount() {
    // TODO - use the react router
    const viewId = window.location.hash.replace('#/', '')
    if (new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$').test(viewId)) {
      store.startView(viewId)
    }
  }

  handleChange = (event: React.ChangeEvent, value: number) => {
    store.updateTab(value)
  };

  render() {
    const { name } = store;
    const mapLink = `/maps/#/${store.viewId}`
    return (
      <div className={css.root}>
        <AppBar className={css.header} position="static" color="default">
          <Toolbar>
            <Typography variant="title" color="inherit" className={css.flex}>
              {name}
            </Typography>
            <div className={css.grow} />
            <Reports locations={store.locations} />
            <div className={css.grow} />
            <Button href={mapLink}>
              Go to maps
            </Button>
            <div className={css.grow} />
            <OxygenLimits store={store} />
          </Toolbar>
        </AppBar>
        <div className={css.content}>
          <div className={css.loggers}>
            <div className={css.cageBoxRow}>
              <CageBoxList cages={store.cages} oxygenMinimum={store.oxygenMinimum} />
            </div>
            <Tabs value={store.whichTab} onChange={this.handleChange}>
              <Tab label="Past half hour" />
              <Tab label="Past 3 hours" />
              <Tab label="Past 6 hours" />
              <Tab label="Past 12 hours" />
              <Tab label="Past 24 hours" />
              <Tab label="Past week" />
              <Tab label="Past month" />
            </Tabs>
            <div className={css.chartsRow}>
              {store.chartData.oxygen.length > 0 && <TimeSeriesChart loggers={store.loggers} chartData={store.chartData} />}
              {store.chartData.ph.length > 0 && <TimeSeriesChartPH loggers={store.loggers} chartData={store.chartData} />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default hot(module)(App)


// WEBPACK FOOTER //
// ./src/App.tsx